export const AUTH_KEY = 'crossfactory-user'
export const BRANCH_KEY = 'crossfactory-branch-id'
